import { getBoolVariation, getVariation } from './init';
export var enableNewCityPicker = function (defaultValue) {
    return getBoolVariation('city-picker-2.0', defaultValue);
};
export var isDismissLocalCurrencyLabel = function () {
    return getBoolVariation('mfrd-2995-dismiss-local-currency-label', false);
};
export var newVersionOPaymenAccount = function () {
    return getBoolVariation('new_version_of_payment_account', false);
};
export var onlyOneCurrencyHideSeaLocalCurrrency = function () {
    return getBoolVariation('only-one-hide-local-currrency', false);
};
export var asyncOCRinvoice = function () {
    return getBoolVariation('async-ocr-invoice', false);
};
export var enableHidingFeeTypeCode = function () {
    return getBoolVariation('cyxq-70919-hide-feeType-code', true);
};
export var useApiExpenseMoney = function () {
    return getBoolVariation('cyxq-70702-use-api-expense-money', false);
};
export var useDepartmentVisible = function () {
    return getBoolVariation('mfrd-3133-department-visible', false);
};
export var enableRecordOptimization = function () {
    return getBoolVariation('mfrd-3830-record-optimization', false);
};
export var enableStaffApiSwitch = function () {
    return getBoolVariation('mfrd-4278-staff-api-switch', false);
};
export var enableOtherInvoiceByDimension = function () {
    return getBoolVariation('fird-4844-invoice-by-dimension', false);
};
export var enableSupportOfflineMessage = function () {
    return getBoolVariation('mfrd-3923-support-offline', false);
};
export var enableHidingFinishedBills = function () {
    return window.isInWeComISV || getBoolVariation('mfrd-3156-get-rid-of-finished-bills', false);
};
export var supportBillDetailsSwitchingInDrawer = function () {
    return enableCustomExtendButton();
};
export var enableCommentOptimization = function () {
    return getBoolVariation('mfrd-4689', false);
};
export var enableFlowOptimization = function () {
    return getBoolVariation('cyxq-77804-flow-optimization', false);
};
export var enableCheckingVisibilityBeforeClearingAccounts = function () {
    return getBoolVariation('mfrd-4595', false);
};
export var enableCustomExtendButton = function () {
    return getBoolVariation('custom-extend-button', false);
};
export var enableCustomExtendButtonCopyInView = function () {
    return getBoolVariation('custom-extend-button-copy-in-view', false);
};
export var enableReCheck = function () {
    return getBoolVariation('fird-5365', false);
};
export var enableRecordSearchOptimization = function () {
    return getBoolVariation('cyxq-78696-record-search', false);
};
export var enableFlowHiddenFields = function () {
    var value = getVariation('mfrd-3670-flow-hidden-field', 'UNOPEN');
    var hasDetail = ['READORWRITE', 'READORWRITE_DETAIL'].includes(value);
    return {
        value: value,
        handleDetail: !!hasDetail
    };
};
export var enableImportApportionOptimization = function () {
    return getBoolVariation('cyxq-77804', false);
};
export var enableInvoiceRiskCheck = function () {
    return getBoolVariation('fird-5567-invoice-risk-check', false);
};
export var enableCacheApprovalComments = function () {
    return getBoolVariation('MFRD-5342', false);
};
export var enableOnlyManualTriggerAutoDetails = function () {
    return getBoolVariation('cyxq-78809-only-manual-trigger-auto-details', false);
};
export var enableRelatedDetailsOptimization = function () {
    return getBoolVariation('mfrd-5147', false);
};
export var getBillEditPerfOptimizations = function () {
    var value = getVariation('mfrd-5536-bill-edit-optimization', 'NULL');
    var optimizations = value === null || value === void 0 ? void 0 : value.split(',');
    return {
        tableVMOptimization: optimizations === null || optimizations === void 0 ? void 0 : optimizations.includes('TABLE_VM'),
        staffsOptimization: optimizations === null || optimizations === void 0 ? void 0 : optimizations.includes('STAFF_API'),
        billSubmitTrack: optimizations === null || optimizations === void 0 ? void 0 : optimizations.includes('BILL_SUBMIT_TRACK'),
        billLoadingTrack: optimizations === null || optimizations === void 0 ? void 0 : optimizations.includes('BILL_LOADING_TRACK'),
    };
};
export var enableModifyApprovalWrittenOffAmountChange = function () {
    return getBoolVariation('cyxq-82166-modify-approval-written-off-amount-change', false);
};
export var enableForeignMoneyOptimization = function () {
    return getBoolVariation('cyxq-82449', false);
};
export var enableOptimizeTableNoGroup = function () {
    return getBoolVariation('mfrd-5536-never-cache-table-no-group', false);
};
export var enableNewDisplayValue = function () {
    return getBoolVariation('cyxq-83197', false);
};
export var enableBillRenderOptimization = function () {
    return getBoolVariation('mfrd-5614-bill-render-optimization', false);
};
export var enableFeeTypeRenderOptimization = function () {
    return getBoolVariation('mfrd-5614-render-optimize', false);
};
export var enableKeepingDrawerOpenAfterApproveOrReject = function () {
    return enableCustomExtendButton();
};
export var enableNewOrderCard = function () {
    return getBoolVariation('fkrd-4314-new-order-card', false);
};
export var enableRelevantApplyOrderLazyLoading = function () {
    return getBoolVariation('relevant-apply-order-lazy-loading', false);
};
export var enableRecoveryRateOptimization = function () {
    return getBoolVariation('mfrd-5566-receivedMoney-sippory-modify-modifying', false);
};
export var enableTaxAmountOptimization = function () {
    return getBoolVariation('CYXQ-84394', false);
};
export var enableDepartmentLazyLoading = function () {
    return getBoolVariation('FKXM-45', false);
};
export var removeDepartmentVisiblity = function () {
    return getBoolVariation('FXXM-31', false);
};
export var enableDataLinkAssignLog = function () {
    return getBoolVariation('cyxq-86151');
};
export var enableNewBillLoadingOptimization = function () {
    return getBoolVariation('fkxm-47-new-bill-loading-optimization', false);
};
export var enableCommentRejectorOptimization = function () {
    return getBoolVariation('cyxq-86805', false);
};
export var enableWebOptPerf = function () {
    return getBoolVariation('fkxm-81-web-opt-perf', false);
};
export var enableFlowInfoRiskWarningAsync = function () {
    return getBoolVariation('web-flow-info-risk-warning-async', false);
};
export var enableTaxAmountShow = function () {
    return getBoolVariation('cyxq-86578', false);
};
export var enablePayerInfoCheckOptimization = function () {
    return getBoolVariation('cyxq-86873', false);
};
export var enableStaffsLazyLoad = function () {
    return getBoolVariation('staff-select-lazyload', false);
};
export var enableRefCPV2LoadTypeOptimization = function () {
    return getBoolVariation('cyxq-86988-refcpv2-load-type-optimization', false);
};
export var enableFMPOptimization = function () {
    return getBoolVariation('pc-fmp-optimization', false);
};
export var enableCYXQ87454RestoreLinkedPayee = function () {
    return getBoolVariation('cyxq-87454', false);
};
export var enableAssignValueToOriginalOptimization = function () {
    return getBoolVariation('SKBBU-186', false);
};
export var enableDewuUiUpdate = function () {
    return getBoolVariation('dewu-ui-update', false);
};
export var enableCYXQ88583DateEndOfDayValue = function () {
    return getBoolVariation('cyxq-88583-date-end-of-day-value', false);
};
export var enableLoginLimitLogoutAfterClose = function () {
    return getBoolVariation('fss-login-limit-logout-after-close', false);
};
export var enableApportionInactiveEntityLabel = function () {
    return getBoolVariation('cyxq-88178-apportion-inactive-entity-label', false);
};
export var enableSubmitCurrencyRateConsistencyCheck = function () {
    return getBoolVariation('submit-currency-rate-consistency-check', false);
};
